import { BRAND } from "@/brand";

// Logo asset. Replace this single URL to update the brand mark everywhere.
export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_maria-ply/artifacts/y3r7ccah_SPARKCURVE%20ICON.png";

/**
 * Brand mark — displays the SparkField Ops logo image.
 * Passing `bg="tile"` keeps the old rounded blue tile (useful on very light
 * surfaces if extra contrast is ever needed).
 */
export default function BrandLogo({ size = 40, className = "", bg = "none" }) {
  const dim = `${size}px`;
  if (bg === "tile") {
    return (
      <span
        data-testid="brand-logo"
        style={{ width: dim, height: dim }}
        className={`inline-flex items-center justify-center rounded-2xl bg-gradient-to-br from-sky-400 via-blue-500 to-blue-700 shadow-[0_10px_25px_-5px_rgba(59,130,246,0.55)] p-1.5 ${className}`}
      >
        <img src={LOGO_URL} alt={BRAND.companyName} className="w-full h-full object-contain" draggable="false" />
      </span>
    );
  }
  return (
    <img
      src={LOGO_URL}
      alt={BRAND.companyName}
      data-testid="brand-logo"
      draggable="false"
      style={{ width: dim, height: dim }}
      className={`inline-block object-contain drop-shadow-[0_2px_6px_rgba(59,130,246,0.35)] ${className}`}
    />
  );
}
